var _defs, _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrandtalk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.74 13.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1e3f76;}.cls-2{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 6.87,
    cy: 6.87,
    r: 6.87
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.35,9.2V8.72a1.74,1.74,0,0,0-.84-.21H6.4A1.88,1.88,0,0,0,4.52,10.4a.38.38,0,0,0,.38.37H9a.38.38,0,0,0,.3-.17l-.67-.67A1,1,0,0,1,8.35,9.2ZM7,8A1.4,1.4,0,1,0,5.56,6.6,1.39,1.39,0,0,0,7,8Zm4.42,1.18-1-1A.7.7,0,0,0,9.9,8H9a.35.35,0,0,0-.35.35V9.2a.71.71,0,0,0,.21.49l1,1a.34.34,0,0,0,.49,0l1-1A.36.36,0,0,0,11.38,9.17Zm-2-.23a.26.26,0,0,1-.26-.26.26.26,0,0,1,.26-.26.26.26,0,0,1,0,.52Z",
    transform: "translate(-1.13 -1.13)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandtalk);
export default __webpack_public_path__ + "static/media/brandtalk.58866bffa5cf022d8cbfdd9762c1a37b.svg";
export { ForwardRef as ReactComponent };